"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Tab", {
  enumerable: true,
  get: function get() {
    return _Tab.default;
  }
});
Object.defineProperty(exports, "TabProps", {
  enumerable: true,
  get: function get() {
    return _Tab.TabProps;
  }
});
Object.defineProperty(exports, "TabIcon", {
  enumerable: true,
  get: function get() {
    return _Tab.TabIcon;
  }
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _context = require("./context");

var _styles = require("./styles");

var _Tab = _interopRequireWildcard(require("./Tab"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Tabs = (0, _react.forwardRef)(function (_ref, ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'normal' : _ref$size,
      children = _ref.children,
      onChange = _ref.onChange,
      selectedId = _ref.selectedId,
      defaultSelectedId = _ref.defaultSelectedId,
      _ref$renderHiddenTabs = _ref.renderHiddenTabsContent,
      renderHiddenTabsContent = _ref$renderHiddenTabs === void 0 ? true : _ref$renderHiddenTabs,
      rest = _objectWithoutProperties(_ref, ["size", "children", "onChange", "selectedId", "defaultSelectedId", "renderHiddenTabsContent"]);

  // This is a ref to store the first tab id. It is used to store the value if
  // some state changes and the tab gets remounted.
  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      firstRegisteredId = _useState2[0],
      setFirstRegisteredId = _useState2[1];

  var _useState3 = (0, _react.useState)(new Map()),
      _useState4 = _slicedToArray(_useState3, 2),
      registeredTabs = _useState4[0],
      setRegisteredTabs = _useState4[1];

  var enabledIds = (0, _react.useMemo)(function () {
    return Array.from(registeredTabs).filter(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          _id = _ref3[0],
          data = _ref3[1];

      return data.isDisabled === false;
    }).map(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 1),
          id = _ref5[0];

      return id;
    });
  }, [registeredTabs]);

  var _useMemo = (0, _react.useMemo)(function () {
    return enabledIds;
  }, [enabledIds]),
      _useMemo2 = _slicedToArray(_useMemo, 1),
      firstTabId = _useMemo2[0];

  var _useState5 = (0, _react.useState)(defaultSelectedId),
      _useState6 = _slicedToArray(_useState5, 2),
      uncontrolledActiveId = _useState6[0],
      setUncontrolledActiveId = _useState6[1];

  var activeId = (0, _react.useMemo)(function () {
    return selectedId || uncontrolledActiveId || firstRegisteredId || firstTabId;
  }, [selectedId, uncontrolledActiveId, firstRegisteredId]);
  var register = (0, _react.useCallback)(function (id, data) {
    setFirstRegisteredId(function (oldState) {
      return !oldState && !data.isDisabled ? id : undefined;
    });
    setRegisteredTabs(function (oldState) {
      var newMap = new Map(oldState);
      newMap.set(id, data);
      return newMap;
    });
    return function () {
      setRegisteredTabs(function (oldState) {
        var newMap = new Map(oldState);
        newMap.delete(id);
        return newMap;
      });
    };
  }, []);
  var activate = (0, _react.useCallback)(function (id) {
    onChange && onChange(id);
    var tabData = registeredTabs.get(id);

    if (tabData && tabData.ref.current) {
      tabData.ref.current.focus();
    }

    if (!selectedId) {
      setUncontrolledActiveId(id);
    }
  }, [selectedId, registeredTabs, onChange]);
  var onKeyDown = (0, _react.useCallback)(function (event) {
    var totalIds = enabledIds.length;
    var activeIdx = enabledIds.indexOf(activeId);
    var newActiveIdx = activeIdx;

    switch (event.key) {
      case 'ArrowLeft':
        newActiveIdx = (activeIdx - 1 + totalIds) % totalIds;
        break;

      case 'ArrowRight':
        newActiveIdx = (activeIdx + 1) % totalIds;
        break;

      case 'Home':
        newActiveIdx = 0;
        break;

      case 'End':
        newActiveIdx = totalIds - 1;
        break;
    }

    if (newActiveIdx !== activeIdx) {
      activate(enabledIds[newActiveIdx]);
    }
  }, [activeId, enabledIds, activate]);
  var values = (0, _react.useMemo)(function () {
    return {
      register: register,
      activeId: activeId,
      activate: activate,
      size: size,
      onKeyDown: onKeyDown
    };
  }, [register, activeId, activate, size, onKeyDown]);
  return _react.default.createElement(_context.TabsContextProvider, {
    value: values
  }, _react.default.createElement(_styles.Container, _extends({}, rest, {
    ref: ref
  }), _react.default.createElement(_styles.TabList, null, children), Array.from(registeredTabs, function (_ref6, index) {
    var _ref7 = _slicedToArray(_ref6, 2),
        id = _ref7[0],
        data = _ref7[1];

    var isActive = id === activeId || !activeId && index === 0;
    return _react.default.createElement(_styles.TabContent, {
      key: id,
      id: "tab-panel-".concat(id),
      "aria-hidden": !isActive || !data,
      "aria-labelledby": "tab-".concat(id),
      hidden: !isActive || !data,
      role: "tabpanel",
      tabIndex: isActive ? 0 : -1
    }, (isActive || renderHiddenTabsContent) && data && data.content);
  })));
});
Tabs.displayName = 'Tabs'; // @ts-ignore

Tabs.propTypes = {
  size: _propTypes.default.oneOf(['normal', 'large']),
  selectedId: _propTypes.default.string,
  defaultSelectedId: _propTypes.default.string,
  renderHiddenTabsContent: _propTypes.default.bool,
  onChange: _propTypes.default.func
};
Tabs.defaultProps = {
  size: 'normal',
  selectedId: undefined,
  defaultSelectedId: undefined,
  renderHiddenTabsContent: true,
  onChange: undefined
};
var _default = Tabs;
exports.default = _default;